/**
 * This file is used to customize/override Gatsby's browser APIs.
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Import global CSS files
import '@assets/css/icomoon.css';
import '@assets/css/bootstrap.css';
import '@assets/css/style.css';
